/**
 * @file src/components/organisms/YieldBearingAssetListItem/YieldBearingAssetListItem.tsx
 * @description This file defines the YieldBearingAssetListItem component, which displays a list item for a yield-bearing asset, including its icon, name, and ticker. The component supports custom styling and layout options.
 * @module YieldBearingAssetListItem
 */

import React, { FC } from 'react';
import { ListItem, ListItemProps, TokenIcon } from '@/components';
import { YieldBearingAssetInterface } from '@/interfaces';
import { tokenToString } from 'typescript';

export interface YieldBearingAssetListItemProps
  extends Omit<ListItemProps, 'mainText' | 'subText'> {
  yieldBearingAsset: YieldBearingAssetInterface;
}

const YieldBearingAssetListItem: FC<YieldBearingAssetListItemProps> = ({
  yieldBearingAsset,
  isHeader = false,
  leftIcon,
  leftIconUrl,
  leftIconWidth,
  leftIconHeight,
  ...rest
}) => {
  // Adjust icon size based on the `isHeader` flag
  const iconWidth = leftIconWidth ?? (isHeader ? 40 : 36);
  const iconHeight = leftIconHeight ?? (isHeader ? 40 : 36);

  const renderLeftIcon = () => {
    return leftIcon ? (
      leftIcon
    ) : (
      <TokenIcon
        key={`${yieldBearingAsset.ticker}-${Math.random()}`}
        tokenSymbol={yieldBearingAsset.ticker}
        alt={yieldBearingAsset.name}
        width={iconWidth}
        height={iconHeight}
      />
    );
  };

  return (
    <ListItem
      isHeader={isHeader}
      mainText={yieldBearingAsset.name}
      subText={yieldBearingAsset.ticker}
      leftIcon={renderLeftIcon()}
      leftIconWidth={iconWidth}
      leftIconHeight={iconHeight}
      leftIconUrl={leftIconUrl}
      {...rest}
    />
  );
};

export default YieldBearingAssetListItem;
